// import i18n from '@/i18n';
//存放数据
const state = {
  navInfo: [
    // {id: 7, name: "双语对齐", code: "alignment", icon: "termBankIcon", url: "/home/memory/alignment"},
    // {id: 6, name: "记忆库", code: "memory_lib", icon: "memoryBankIcon", url: "/home/memory/memoryBank"}
  ],
  userInfo: {},
  rootId: null,
  showhidden: true, //消息红点
  userroleresourceList: [], //权限作业菜单
  memberInfo: {}, // 会员状态
  isRouteDataReady: false, // 标识路由数据是否已就绪
};
export default state;
